import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { ProducteditComponent } from './product-edit.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';


const routes: Routes = [{
	path: '',
	data: {
      title: 'Product Configuration',
      urls: [{title: 'Dashboard',url: '/'},{title: 'Product Configuration'}]
    },
	component: ProducteditComponent
}];

@NgModule({
	imports: [
    	FormsModule,
    	CommonModule, 
		NgbModule.forRoot(),
    	RouterModule.forChild(routes)
    ],
	declarations: [ProducteditComponent]
})
export class ProducteditModule { }


// WEBPACK FOOTER //
// /Users/sheashay/Sites/ihsaa-ams-design/src/app/pages/ecommerce/product-edit/product-edit.module.ts